module.exports = __webpack_public_path__ + "static/media/arrow.6f801093.png";